import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import styles from './MobileCloseButton.module.scss';

type Props = {
    'onClick': () => void;
    'className'?: string;
    'aria-label'?: string;
};

const MobileCloseButton: FunctionComponent<Props> = ({ onClick, className, 'aria-label': ariaLabel }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={className ? className : styles.root}
            aria-label={ariaLabel || 'Close'}
        >
            <FontAwesomeIcon icon={faXmark} />
        </button>
    );
};

export default MobileCloseButton;
